/* eslint-disable max-lines */
import { FC } from "react"
import { Translate } from "../../../../../constant/Translate"
import { Card } from "../../../../../_webui/layout/components/Card"
import { Layout } from "../../../../../_webui/layout/components/Layout"
import { Table } from "../../../../../_webui/layout/components/Table"
import { TotalRecords } from "../../../../../_webui/layout/components/Typography/TotalRecords"
import { SchedulesButtonGroup } from "../../components/list/ButtonGroup"
import { SchedulesFormSearch } from "../../components/list/FormSearch"
import { SchedulesListDataType } from "../../models/list"
import { useSchedulesList } from "./modules/useList"
import { ModalConfirm } from "../../../../../_webui/layout/components/Modal/Confirm"

const { MESSAGE_C0061, TEXT_T190 } = Translate

export const SchedulesList: FC = () => {
  const {
    arrivalCities,
    breadcrumbItems,
    columns,
    countries,
    dataSource,
    departments,
    disabledDateTo,
    dispatchType,
    dispatchTypeDetail,
    form,
    fullName,
    goBack,
    goToAttention,
    goToSafety,
    goToSchedulesAdd,
    goToSchedulesConfirmDelete,
    goToSchedulesDetail,
    goToSchedulesEdit,
    handleCancelEmptySearchCondition,
    handleCancelModalExport,
    handleExportFile,
    handleOpenModalExport,
    handleSearch,
    isDisabledArrivalCity,
    isDisabledBtnCreateOrSend,
    isDisabledBtnDelete,
    isDisabledBtnRefer,
    isDisabledDispatchTypeDetail,
    isFromSCR114UserSearch,
    isHiddenBtnCreateOrSendAttentions,
    isHiddenBtnCreateOrSendSafeties,
    isHiddenBtnDelete,
    isHiddenBtnEdit,
    isHiddenBtnExportCsv,
    isHiddenBtnExportExcel,
    isHiddenBtnExportExcelSafeties,
    isHiddenBtnExportExcelTravelers,
    isHiddenBtnRefer,
    isHiddenBtnResetForm,
    isHiddenBtnSearchBasic,
    isLoading,
    isLoadingLayout,
    isOpenEmptySearchCondition,
    isOpenModalExport,
    isPathnameSchedules,
    isPathnameSchedulesOrTravelers,
    isPathnameTravelers,
    isResetTable,
    messageConfirmDownload,
    onBlurBasic,
    onChange,
    onChangeArrivalCity,
    onChangeArrivalCountryCode,
    onChangeDispatchType,
    onChangeTable,
    onClickReset,
    onFinish,
    onKeyDownBasic,
    perItem,
    purposeTravel,
    rowSelection,
  } = useSchedulesList()

  return (
    <Layout
      breadcrumbItems={breadcrumbItems}
      isLoadingLayout={isLoadingLayout}
      title={TEXT_T190}
    >
      <Card heading={TEXT_T190} isLoading={isLoading}>
        {!isFromSCR114UserSearch && (
          <SchedulesFormSearch
            arrivalCities={arrivalCities}
            countries={countries}
            departments={departments}
            disabledDateTo={disabledDateTo}
            dispatchType={dispatchType}
            dispatchTypeDetail={dispatchTypeDetail}
            form={form}
            fullName={fullName}
            handleSearch={handleSearch}
            isDisabledArrivalCity={isDisabledArrivalCity}
            isDisabledDispatchTypeDetail={isDisabledDispatchTypeDetail}
            isHiddenBtnResetForm={isHiddenBtnResetForm}
            isHiddenBtnSearchBasic={isHiddenBtnSearchBasic}
            isPathnameSchedules={isPathnameSchedules}
            onBlurBasic={onBlurBasic}
            onChangeArrivalCity={onChangeArrivalCity}
            onChangeArrivalCountryCode={onChangeArrivalCountryCode}
            onChangeDispatchType={onChangeDispatchType}
            onClickReset={onClickReset}
            onKeyDownBasic={onKeyDownBasic}
            purposeTravel={purposeTravel}
          />
        )}
        <TotalRecords
          perItem={perItem}
          titleLeft={TEXT_T190}
          total={dataSource?.length}
        />
        <Table
          columns={columns}
          dataSource={dataSource}
          isResetTable={isResetTable}
          onChange={onChange}
          onChangeTable={onChangeTable}
          rowKey={(record: SchedulesListDataType) =>
            record.info.travelScheduleId
          }
          rowSelection={rowSelection}
        />
        <SchedulesButtonGroup
          goBack={goBack}
          goToAttention={goToAttention}
          goToSafety={goToSafety}
          goToSchedulesAdd={goToSchedulesAdd}
          goToSchedulesConfirmDelete={goToSchedulesConfirmDelete}
          goToSchedulesDetail={goToSchedulesDetail}
          goToSchedulesEdit={goToSchedulesEdit}
          handleOpenModalExport={handleOpenModalExport}
          isDisabledBtnCreateOrSend={isDisabledBtnCreateOrSend}
          isDisabledBtnDelete={isDisabledBtnDelete}
          isDisabledBtnRefer={isDisabledBtnRefer}
          isFromSCR114UserSearch={isFromSCR114UserSearch}
          isHiddenBtnCreateOrSendAttentions={isHiddenBtnCreateOrSendAttentions}
          isHiddenBtnCreateOrSendSafeties={isHiddenBtnCreateOrSendSafeties}
          isHiddenBtnDelete={isHiddenBtnDelete}
          isHiddenBtnEdit={isHiddenBtnEdit}
          isHiddenBtnExportCsv={isHiddenBtnExportCsv}
          isHiddenBtnExportExcel={isHiddenBtnExportExcel}
          isHiddenBtnExportExcelSafeties={isHiddenBtnExportExcelSafeties}
          isHiddenBtnExportExcelTravelers={isHiddenBtnExportExcelTravelers}
          isHiddenBtnRefer={isHiddenBtnRefer}
          isPathnameTravelers={isPathnameTravelers}
          isPathnameSchedulesOrTravelers={isPathnameSchedulesOrTravelers}
        />
        <ModalConfirm
          isOpen={isOpenModalExport}
          onCancel={handleCancelModalExport}
          onOk={handleExportFile}
        >
          {messageConfirmDownload}
        </ModalConfirm>
        <ModalConfirm
          isOpen={isOpenEmptySearchCondition}
          onCancel={handleCancelEmptySearchCondition}
          onOk={() => {
            if (typeof onFinish === "function") {
              onFinish(form?.getFieldsValue())
            }
          }}
        >
          {MESSAGE_C0061}
        </ModalConfirm>
      </Card>
    </Layout>
  )
}
